<template>
  <div
    class="row project-visual"
    :class="{ 'project-visual--inview': isVisible }"
    v-observe-visibility="{
      callback: visibilityChanged,
      once: true,
      throttle: 200,
    }"
  >
    <div class="col-xs-12 col-md-6" @click="onClick(indexVisual1)">
      <div
        class="project-visual__wrapper"
        @mouseover="toggleCursor"
        @mouseleave="toggleCursor"
      >
        <v-lazy-image
          :srcset="srcset(visuals.visual1)"
          sizes="50vw"
          :src="fullURL(visuals.visual1)"
        />
      </div>
    </div>
    <div class="col-xs-12 col-md-6" @click="onClick(indexVisual2)">
      <div
        class="project-visual__wrapper"
        @mouseover="toggleCursor"
        @mouseleave="toggleCursor"
      >
        <v-lazy-image
          :srcset="srcset(visuals.visual2)"
          sizes="50vw"
          :src="fullURL(visuals.visual2)"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'doubleProjectVisual',
  props: {
    visuals: Object,
    clickMethod: Function,
    indexVisual1: Number,
    indexVisual2: Number,
  },
  data: function() {
    return {
      isVisible: false,
      isHover: false,
    };
  },
  methods: {
    srcset: function(visual) {
      const url480 = this.updateImageUrl(`${visual.fields.file.url}?w=480`);
      const url767 = this.updateImageUrl(`${visual.fields.file.url}?w=767`);
      const urlFull = this.updateImageUrl(`${visual.fields.file.url}?w=1110`);
      return `${url480} 480w, ${url767} 767w, ${urlFull} 1110w`;
    },
    fullURL: function(visual) {
      return this.updateImageUrl(`${visual.fields.file.url}?w=1110`);
    },
    onClick: function(index) {
      this.clickMethod(index);
    },
    visibilityChanged(isVisible) {
      this.isVisible = isVisible;
    },
    toggleCursor() {
      this.isHover = !this.isHover;
      this.$store.commit('setCursor', this.isHover);
    },
  },
};
</script>

<style scoped></style>
